import { VehicleGraphic } from "../design/vehicleGraphics";
import type { VehiclePreset } from "../types/traffic";

type VehicleArtProps = {
  preset: VehiclePreset;
  color: string;
  className?: string;
};

export function VehicleArt({ preset, color, className = "" }: VehicleArtProps) {
  return (
    <svg
      className={`vehicle-art ${className}`}
      viewBox="0 0 180 240"
      style={{ color }}
      data-vehicle={preset}
      aria-hidden="true"
    >
      <VehicleGraphic preset={preset} />
    </svg>
  );
}
